var AppointmentsRescheduleModalDataTestId = /* @__PURE__ */ ((AppointmentsRescheduleModalDataTestId2) => {
  AppointmentsRescheduleModalDataTestId2["APPOINTMENT_RESCHEDULE_MODAL"] = "appointments--reschedule-modal";
  AppointmentsRescheduleModalDataTestId2["APPOINTMENT_RESCHEDULE_PROFESSIONAL_NAME"] = "appointments--reschedule-professional-name";
  AppointmentsRescheduleModalDataTestId2["APPOINTMENT_RESCHEDULE_DAY_COLUMN"] = "appointments--reschedule-day-column";
  AppointmentsRescheduleModalDataTestId2["APPOINTMENT_RESCHEDULE_SLOT"] = "appointments--reschedule-slot";
  AppointmentsRescheduleModalDataTestId2["APPOINTMENT_RESCHEDULE_PREV_DAYS"] = "appointments--reschedule-prev-days";
  AppointmentsRescheduleModalDataTestId2["APPOINTMENT_RESCHEDULE_NEXT_DAYS"] = "appointments--reschedule-next-days";
  AppointmentsRescheduleModalDataTestId2["APPOINTMENT_RESCHEDULE_LOAD_MORE_SLOTS"] = "appointments--reschedule-load-more-slots";
  AppointmentsRescheduleModalDataTestId2["APPOINTMENT_RESCHEDULE_EMPTY"] = "appointments--reschedule-empty";
  AppointmentsRescheduleModalDataTestId2["APPOINTMENT_RESCHEDULE_SKELETON"] = "appointments--reschedule-skeleton";
  return AppointmentsRescheduleModalDataTestId2;
})(AppointmentsRescheduleModalDataTestId || {});
export {
  AppointmentsRescheduleModalDataTestId
};
